import { useAtom } from 'jotai';
import { scheduleWelcomeOpenAtom } from '../schedule-welcome-modal-open/schedule-welcome-modal-open';

export function useScheduleWelcomeModalOpen() {
  const [scheduleWelcomeModalOpen, setScheduleWelcomeModalOpen] = useAtom(scheduleWelcomeOpenAtom);
  return {
    scheduleWelcomeModalOpen,
    setScheduleWelcomeModalOpen,
  };
}
